import update from 'immutability-helper';
import { EnumtestActions } from "./testActions";

const initialState = {
    textArea: "",
    checkBox: false,
    selected: "",
    options: [{ key: "uno", value: 1 }, { key: "due", value: 2 }, { key: "tre", value: 3 }, { key: "quattro", value: 4 }, { key: "cinque", value: 5 }, { key: "sei", value: 6 }],
    showModalDelete: null,
    showModalSave: null,
}

const testReducer = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }
    let moduleName = "[testReducer.js] ";
    switch (action.type) {
        case EnumtestActions.CHANGE_SELECT:
            console.log(moduleName + " CHANGE_SELECT")
            return update(state, { $merge: { selected: action.newSelectValue } });
        case EnumtestActions.CHECK_BOX:
            console.log(moduleName + " CHECK_BOX")
            return update(state, { $merge: { checkBox: !action.check } });
        case EnumtestActions.UPDATE_TESTO:
            console.log(moduleName + " UPDATE_TESTO")
            return update(state, { $merge: { textArea: action.valueTextField } });

        case EnumtestActions.SHOW_POPOUP_DELETE:
            return update(state, action.showPopUpDelete);

        case EnumtestActions.SHOW_POPOUP_SAVE:
            return update(state, action.showPopUpSave);

        default:
            return state;
    }
}

export default testReducer;